module.exports = __webpack_public_path__ + "img/slide1-mobile.651ee0a1.png";